import type { FetchService, ServiceName } from 'runtimes-shared'
import insightsBaseUrl from './insights/baseUrl'
import resourceBaseUrl from './resource/baseUrl'
import requireAuthContext from './authorization/requireAuthContext'

type ServiceConfig = { baseUrl: string; authenticated: boolean }

const services: Record<ServiceName, ServiceConfig> = {
  insights: { baseUrl: insightsBaseUrl, authenticated: true },
  resources: { baseUrl: `${resourceBaseUrl}/resources`, authenticated: false },
}

const gzipBody = async (init?: RequestInit): Promise<RequestInit | undefined> => {
  if (!init?.body) return init
  const request = new Request('', { method: 'POST', body: init.body })
  const blob = await request.blob()
  const compressed = await new Response(blob.stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer()
  return {
    ...init,
    body: compressed,
    headers: { ...init.headers, 'Content-Encoding': 'gzip' },
  }
}

const fetchService: FetchService = async (service, path, init) => {
  const { baseUrl, authenticated } = services[service]
  const url = `${baseUrl}${path}`
  if (!authenticated) return fetch(url, init)

  if (service === 'insights') init = await gzipBody(init)

  const authContext = await requireAuthContext()
  return fetch(url, {
    ...init,
    headers: {
      ...init?.headers,
      Authorization: `Bearer ${authContext.accessToken}`,
    },
  })
}

export default fetchService
